module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAMAAABIkLa5AAAAS1BMVEUAAABxcXHn5+f7+/tkZGTGxsarq6v///////8oKCg9PT2hoaF9fX1ISEje3t4FBQX09PQZGRmKiopbW1sMDAy5ubmXl5fa2tpPT09BLDcXAAAAGXRSTlOAgICAf4CAgHmAgH+Af395gICAgICAgHx8LjyngwAAAMhJREFUGBlVwQlywjAQAMGxJXlWvk/g/y+NIVUp0o3/rb4RfrmAYzYIv5Q+V7iC8KNr9uQtOcNMeBsq8FBHzjQzEWrmrXOdy7WdTguhEx9N3qjrzNothBNfjrZP/ULs3Grex6MCozq9eAL56cdVqaMaZBh06OvRaqrQJ4OFRjO3bdUO6AwWWgvT0VQ6LcBgsNA6ohWKjkBrMJBtz7GBlxZg0CAy2XU6+0EfwK4G4YOz6bqrNEBfvAWhae+3Ddia4kfgr3Zuk39+ANdBCq00pE9oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/images/socialLink/logo_weibo.png
// module id = 718
// module chunks = 0